import React from "react";

import AppLayout from "../../components/layout/AppLayout";
import Breadcrumb from "../../components/layout/Breadcrumb";
import DailyUsageModules from "../../components/dashboard/DailyUsageModules";
import MasterModules from "../../components/dashboard/MasterModules";
import { pageTitleClass } from "../../components/ui/styles";
import { route } from "../../static/route";
import { BreadcrumbType } from "../../types/common";

const breadcrumbItems: BreadcrumbType[] = [
  { label: "હોમ", href: route.dashboard },
  { label: "ડેશબોર્ડ" },
];

const DashboardPage = () => {
  return (
    <AppLayout>
      <div className="mb-2 md:mb-0">
        <Breadcrumb items={breadcrumbItems} />
      </div>

      <div className="flex items-center mb-4 md:mb-6 mt-2">
        <h1 className={pageTitleClass}>ડેશબોર્ડ</h1>
      </div>

      <DailyUsageModules />

      <MasterModules />
    </AppLayout>
  );
};
export default DashboardPage;
